export enum MaterialStatus{
    Public,
    Test
}

export enum MaterialType{
    ProtectionSystems,
    NaturalSoils,
    SoilBioengineeringNaturalVegetation
}

export enum MaterialCategory
{
    Cohesive = 0,
    Gabion = 1,
    Reno = 2,
    MacMat = 3,
    Riprap = 4,
    Custom = 5,
    Other = 6,
    Concrete = 7,
}

// Concrete/Masonry: rigid protection system — no allowable-shear pass/fail.
// Detection of this material is keyed ONLY on this category, never on isDangerousShearStress.
export const isConcrete = (category?: MaterialCategory): boolean => category === MaterialCategory.Concrete;

export enum MaterialBioType{
    Vegetated,
    UnvegetatedWithBioTextile
}

export enum Usage{
    Base,
    Project
}